import { Typography } from '@material-ui/core'
import React from 'react'
import SignatureModel from '../Models/SignatureModel'
import Signature from './Signature'

export interface InformedConsentProps {
  signatureData: SignatureModel
}

const InformedConsent: React.SFC<InformedConsentProps> = ({ signatureData }) => {
  return (
    <div id='informedConsentDiv' style={{ maxHeight: '400px', overflowY: 'scroll' }}>
      <div id='informedConsent'>
        <Typography component='h3' variant='h6' id='informedConsentHeader'>
          CONSENTIMIENTO INFORMADO
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          La <b>teleconsulta</b> es una actividad de la modalidad de atención definida como telemedicina, aprobada por
          el ministerio de salud bajo la{' '}
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.minsalud.gov.co/Normatividad_Nuevo/Resoluci%C3%B3n%20No.%202654%20del%202019.pdf'
          >
            resolución 2654 de 2019
          </a>{' '}
          y tiene como objetivo, prestar el servicio de atención médica a los pacientes que se beneficien de no
          trasladarse a los centros médicos para una consulta presencial en la modalidad convencional.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          La teleconsulta no genera procedimientos a distancia, pero aun así es necesario explicarle los riesgos que
          puede tener. Al tratarse de una atención a distancia, durante la cual pueden omitirse detalles del examen
          físico que en la consulta presencial podrían ser detectados. Si su médico estima que no es seguro por alguna
          condición continuar con la actividad, se lo hará saber y le indicará lo que debe hacer.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Para la realización de la consulta, usted deberá contar con un equipo de comunicación con video, el cual puede
          ser un computador fijo o portátil, una Tablet o un teléfono celular. Además, debe disponer de conexión a
          internet que soporte una video-llamada de buena calidad para que pueda tener contacto visual con su médico.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Los canales de comunicación se encuentran protegidos y garantizamos que la información que se genera durante
          la comunicación no será divulgada ni empleada en ninguna otra actividad diferente de guardar datos en su
          historia clínica.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          En caso de emitir prescripciones Médicas dentro de la atención, se enviarán con firma mediante los medios
          establecidos por la IPS para los trámites pertinentes de acuerdo con las indicaciones de la EPS.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Al proseguir con el procedimiento Ud confirma que ha sido informado y entiende cual es el fin de la actividad,
          las ventajas, los procedimientos, el manejo de los datos personales y los posibles riesgos. Manifiesta,
          además, que está de acuerdo y da su consentimiento para tomar el servicio en esta modalidad.
        </Typography>
        <Signature data={signatureData} />
      </div>
    </div>
  )
}

export default InformedConsent
